import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { UnitsDistributionBase } from '../base/units-distribution.base';

@Component({
    selector: 'ud-asian-handicap',
    templateUrl: './default/asian-handicap/asian-handicap.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslocoModule, PipesModule]
})
export class AsianHandicapComponent extends UnitsDistributionBase {
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }
}
